/**
 * Generated by orval. Do not edit manually.
 */

export type InsiderSolverConfidenceChoice =
  (typeof InsiderSolverConfidenceChoice)[keyof typeof InsiderSolverConfidenceChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsiderSolverConfidenceChoice = {
  never: 'never',
  tried: 'tried',
  occasional: 'occasional',
  regular: 'regular',
  extensive: 'extensive',
} as const
